
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class LevelReportGrid extends Serenity.EntityGrid<LevelReportRow, any> {
        protected getColumnsKey() { return LevelReportColumns.columnsKey; }
        protected getDialogType() { return LevelReportDialog; }
        protected getIdProperty() { return LevelReportRow.idProperty; }
        protected getInsertPermission() { return LevelReportRow.insertPermission; }
        protected getLocalTextPrefix() { return LevelReportRow.localTextPrefix; }
        protected getService() { return LevelReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(0, 3);
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: LevelReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));


            return buttons;

        }
    }
}